"use client";

import { useRouter } from "next/navigation";
import { ArrowLeft } from "lucide-react";

interface BackButtonProps {
    href?: string;
    fallbackHref?: string;
}

export function BackButton({ href, fallbackHref }: BackButtonProps = {}) {
    const router = useRouter();

    const handleClick = () => {
        if (href) {
            router.push(href);
            return;
        }

        if (fallbackHref && window.history.length <= 1) {
            router.push(fallbackHref);
            return;
        }

        router.back();
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            className="mb-8 flex w-fit items-center gap-2 text-sm font-medium text-muted-foreground transition-colors hover:text-primary hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
            <ArrowLeft className="size-5" />
            Back
        </button>
    );
}
